module.exports = __webpack_public_path__ + "img/ch08_03_草莓蛋糕.23d32090.jpg";